import { useEffect } from "react";
import { useGlobalStore } from "@/stores/global-store";
import { Toggle } from "@/components/ui/form/toggle";

/*
 * ThemeSwitcher component
 * This component is used to switch between light and dark themes using daisyUI
 * data-theme attribute is added to the html tag which propagates the theme across the entire app
 */
export const ThemeSwitcher = () => {
  /* Actions */
  const { setTheme } = useGlobalStore((state) => state.appActions);

  /* Stores */
  const theme = useGlobalStore((state) => state.theme);

  /* Handlers */
  const handleSwitch = () => {
    setTheme(theme === "light" ? "dark" : "light");
  };

  /* Side Effects */
  useEffect(() => {
    // set theme in local storage
    localStorage.setItem("theme", theme);
    setTheme(theme);

    // add custom data-theme attribute to html tag required to update theme using DaisyUI
    // this set its across the entire app
    document.documentElement.setAttribute("data-theme", theme);
  }, [theme, setTheme]);

  /* Render */
  return <Toggle defaultChecked={theme === "dark"} onChange={handleSwitch} />;
};
